import { Component, OnInit, Injector, ViewChild, Output, EventEmitter, ViewEncapsulation, Input } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AppConfig } from '@solar/app.config';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelectionList } from '@angular/material/list';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { Site } from 'solar-bo';
import { SelectionModel, SelectionChange } from '@angular/cdk/collections';
import { DashboardService } from '../../services/dashboard.service';
import { Observable } from 'rxjs';
import { DbFilter } from '../db-overview/db-filter-helper';
import { FormControl, NgModel } from '@angular/forms';
import { DB_filter, IDB_filter, DBColumnsEnum } from 'solar-bo';
import { FilterItem, FilterItemCollection, GenFilter, IFilterItemCollection } from './filter';



export interface IDbFilters {
  sites: any[];
  issuetype: any[];
  relevance: any[];
  brandtypes: any[];
  moduletypes: any[];
}
//
@Component({
  selector: 'app-db-filter',
  templateUrl: './db-filter.component.html',
  styleUrls: ['./db-filter.component.scss']
})
export class DBFilterComponent implements OnInit {

  alertmessage = null;
  listerrmessage = '';
  loadinglist = true;
  title = "Filter Dashboard";
  titlesub = "Select criteria to show";
  @Input() dbFilter: GenFilter;
  elemSelected: IFilterItemCollection[] = [];

  public showmodulefilter: boolean = true;

  showsitelist: boolean = false;

  filterColumn = DBColumnsEnum;

  @ViewChild('sites_list') sitesSelectionList: MatSelectionList;
  @ViewChild('issuetype') issuetypeSelectionList: MatSelectionList;
  @ViewChild('relevancetype') relevancetypeSelectionList: MatSelectionList;
  @ViewChild('brandtype') brandtypeSelectionList: MatSelectionList;
  @ViewChild('moduletype') moduletypeSelectionList: MatSelectionList;
  @Output() selectedEvent = new EventEmitter<any>();



  constructor(
    private dashService: DashboardService) {
  }

  ngOnInit() {
    this.loadinglist = false;
  }

  resetall() {

    //this.configureFilter(this.dashService.dbFilterGlobal);

    this.selectionReset(this.sitesSelectionList);
    this.selectionReset(this.issuetypeSelectionList);
    this.selectionReset(this.relevancetypeSelectionList);
    this.selectionReset(this.brandtypeSelectionList);
    this.selectionReset(this.moduletypeSelectionList);
  }

  private selectionReset(filter: MatSelectionList) {
    if (filter) {
      filter.selectAll();
    }
  }

  filtersGet(): IFilterItemCollection[] {
    let elemSelected: IFilterItemCollection[] = [];

    this.selectionGetSelected(elemSelected, DBColumnsEnum.site_id, this.sitesSelectionList);
    this.selectionGetSelected(elemSelected, DBColumnsEnum.issue_type, this.issuetypeSelectionList);
    this.selectionGetSelected(elemSelected, DBColumnsEnum.relevance, this.relevancetypeSelectionList);
    this.selectionGetSelected(elemSelected, DBColumnsEnum.panel_model, this.moduletypeSelectionList);
    this.selectionGetSelected(elemSelected, DBColumnsEnum.panel_brand, this.brandtypeSelectionList);
    this.elemSelected = elemSelected;
    return elemSelected;
  }

  private selectionGetSelected(elemSelected: IFilterItemCollection[], fieldKey: string, filter: MatSelectionList) {
    if (filter && filter.selectedOptions.selected.length > 0) {
      let selected = filter.selectedOptions.selected;
      let filterItemCol = new FilterItemCollection(fieldKey);
      if (selected) {
        for (let elem of selected) {
          let item :FilterItem= elem.value;
          filterItemCol.items.push( item);
          filterItemCol.value.push (item.value);
        }
      }
      
      elemSelected.push(filterItemCol);
    }
  }

  /**
 * Raise event on UI click
 */
  filterBySelection_click(close: boolean = false) {
    this.selectedEvent.next(this.filtersGet());
  }



  onSiteChange(event?: any) {
    //this.issuetypeSelectionList.deselectAll();
    //enviar peticion al servidor para devolver los datos
    //let lst = this.dashService.filterGetColumnFilters(this.filtersGet());
    //this.dbFilter.configureData(lst);
    //console.log("onSiteChange", lst);
  }
  onIssueTypeChange(event?: any) {
    //let lst = this.dashService.filterGetColumnFilters(this.filtersGet());
    //this.dbFilter.configureData(lst);
    //console.log("onIssueTypeChange", lst);
  }
  onRelevanceTypeChange(event?: any) {
    console.log(event);
  }
  onModuleTypeChange(event?: any) {
    console.log(event);
  }



  configureHeaders(title?: string, titlesub?: string) {
    if (title) {
      this.title = title;
    }
    if (titlesub) {
      this.titlesub = titlesub;
    }
  }

  configureFilter(dbFilter: GenFilter) {
    this.dbFilter = dbFilter;

    console.log("configureFilter",this.dbFilter);
    let siteList: any = dbFilter.filterGet(DBColumnsEnum.site_id);
    if (siteList && siteList.items.length > 1) {
      this.showsitelist = true;
    }
    else {
      this.showsitelist = false;
    }
  }

  filtersList: { "name": string, "value": [] , "selected":[]}[] = [];
  configureMatList(){
    for (let item of this.dbFilter.filtersList){

    }
  }

  filterAdd(filterName: string, values: any) {
    let f: any = this.filtersList.find(item => item.name == filterName);
    if (f) {
        f.value = values;
    }
    else {
        f = { "name": filterName, "value": values , "selected":values};
        this.filtersList.push(f);
    }
}



  public static openModal(dialog: MatDialog, dbFilter: GenFilter, title?: string, titlesub?: string, position: any = null): MatDialogRef<DBFilterComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = "900px";
    if (position !== null) {
      dialogConfig.position = position;// { left: '10px', top: '200' };
    }

    //dialogConfig.height = "400px";
    //dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<DBFilterComponent>;
    dialogRef = dialog.open(DBFilterComponent, dialogConfig);
    dialogRef.componentInstance.configureHeaders(title, titlesub);
    dialogRef.componentInstance.configureFilter(dbFilter);

    return dialogRef;
  }

}
